export const LOCAL = 'localhost';
export const DEV = 'dev';
export const STAGING = 'staging';
export const PRODUCTION = 'prod';

let environment;
if (window.location.hostname.includes('localhost')) {
  environment = LOCAL;
} else if (window.location.hostname.includes('d-dashboard')) {
  environment = DEV;
} else if (window.location.hostname.includes('d-ras')) {
  environment = DEV;
} else if (window.location.hostname.includes('s-dashboard')) {
  environment = STAGING;
} else if (window.location.hostname.includes('dashboard')) {
  environment = PRODUCTION;
} else if (window.location.hostname.includes('ras')) {
  environment = PRODUCTION;
} else if (window.location.hostname.includes('passwordreset')) {
  environment = PRODUCTION;
} else if (window.location.hostname.includes('dev')) {
  environment = DEV;
} else if (window.location.hostname.includes('staging')) {
  environment = STAGING;
} else {
  environment = PRODUCTION;
}

const isLocal = environment === LOCAL;
const isDev = environment === DEV;
const isStaging = environment === STAGING;
const isProd = environment === PRODUCTION;

const configuration = {
  constants: {
    LOCAL,
    DEV,
    PRODUCTION,
  },
  environment,
  isLocal,
  isDev,
  isStaging,
  isProd,
  AUTH_COOKIE_NAME: isProd
    ? 'access_token_prod'
    : isDev
      ? 'access_token_dev'
      : isStaging
        ? 'access_token_staging'
        : isLocal
          ? 'access_token_local'
          : 'access_token',
  ENVIRONMENT: isProd
    ? 'prod'
    : isDev
      ? 'dev'
      : isStaging
        ? 'staging'
        : isLocal
          ? 'local'
          : 'local',
  AUTH_DOMAIN: isLocal
    ? 'd-intelligentbuildings.us.auth0.com'
    : isDev
      ? 'd-intelligentbuildings.us.auth0.com'
      : 'auth.ib-services.net',
  AUTH_AUDIENCE: isLocal
    ? 'https://d-intelligentbuildings.us.auth0.com/userinfo'
    : isDev
      ? 'https://d-intelligentbuildings.us.auth0.com/userinfo'
      : 'https://intelligentbuildings.auth0.com/userinfo',
  AUTH_CLIENT_ID: isProd
    ? 'BbBuw4osp1ADuMapMimIb4TAPDS3ZH66'
    : isStaging
      ? '8BUH9OWtkS1owPxnKcbq4gXvYxh4FVWa'
      : isDev
        ? 'aUKKXzo0ZnyilQ2kCNwKoNQvKDCjMkN3'
        : isLocal
          ? 'Unx8xZLRar3cTWrfkyh0UKekjB9pl3YS'
          : 'b67v9OND9mq1dBunXcZikw7tyoM2G2h7',
  AUTH_RESPONSE_TYPE: 'code',
  AUTH_SCOPE: 'openid profile email',
  AUTH_CALLBACK_URL: `${window.location.origin}/auth/callback`,
  API_DOMAIN: isProd
    ? 'https://dashboard-api.ib-services.net'
    : isStaging
      ? 'https://s-dashboard-api.ib-services.net'
      : isDev
        ? 'https://d-dashboard-api.ib-services.net'
        : isLocal
          ? 'http://localhost:8090'
          : 'http://localhost:8090',
  flags: {
    vendorOrgsEnabled: isLocal || isDev,
    useFullStory: false, //isDev || isDevNew || isProd || isProdNew,
  },
};

export default configuration;
